module.exports = __webpack_public_path__ + "b56f41b6172704c0644bdb10ad790a49.MP3";